import { createSelector } from 'reselect'
import equipmentGroupsSelector from './equipmentGroupsSelector'

const equipmentPathsSelector = createSelector(
    equipmentGroupsSelector,
    (equipmentGroups): string[] => equipmentGroups.map((equipmentGroup) => `/${equipmentGroup.id}`),
)

export default equipmentPathsSelector
